import { render, staticRenderFns } from "./FeatureButton.vue?vue&type=template&id=2490b3ae&scoped=true&"
import script from "./FeatureButton.vue?vue&type=script&lang=js&"
export * from "./FeatureButton.vue?vue&type=script&lang=js&"
import style0 from "./FeatureButton.vue?vue&type=style&index=0&id=2490b3ae&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2490b3ae",
  null
  
)

export default component.exports